import { ReactNode } from 'react';
import SkipToMainContent, {
  MAIN_CONTENT_ID,
} from 'src/components/layout/SkipToMainContent';

const BasicLayout = ({ children }: { children: ReactNode }) => {
  return (
    <>
      <SkipToMainContent />
      <div className="px-2 sm:px-4 lg:px-8">
        <div className="flex items-stretch max-w-[600px] mx-auto">
          <main id={MAIN_CONTENT_ID} className="flex-1 min-w-0 pb-5">
            {children}
          </main>
        </div>
      </div>
    </>
  );
};

export default BasicLayout;
